import React, { useRef, useState, useEffect } from "react";
import { Drawer, DrawerContent, useDisclosure } from "@heroui/react";
import ButtonMethodPayment from "../../components/ButtonMethodPayment";
import Invoice from "../../components/Invoice";
import { ReactComponent as Close } from "../../assets/close.svg";
import ButtomSave from "../../components/ButtomSave";
import { isMobile } from "react-device-detect";
import PaymentStatus from "../../components/PaymanetStatus";
import { useStore } from "../../lib/store";
import { AmplitudeLog } from "../../lib/amplitude";
import { HandleShare } from "../..//lib/utils";
import { ScrollArea } from "../../components-shadcn/scroll-area";
import { GenerateInvoice } from "./request_create_invoice";
import { toast } from "sonner";
import Product from "./Product";

type IconKey = "error" | "success" | "processing";

interface Props {
  wide?: boolean
  produto: any
  produto_type: "dinamometro_tracao" | "dinamometro_palmar" | "assinatura"
  formas: "cartao" | "pix" | "boleto";
  entrada: boolean;
}

interface TypePaymentStatus {
  open: boolean;
  icon: IconKey;
  title: string;
  legend: string;
}

const PaymentBoletoCheckout: React.FC<Props> = ({ wide, produto, produto_type, formas, entrada }) => {

  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const openTimeRef = useRef<number>(0);

  useEffect(() => {
    if (isOpen) {
      openTimeRef.current = Date.now();
    }
  }, [isOpen]);

  const getModalTime = () => openTimeRef.current ? Math.floor((Date.now() - openTimeRef.current) / 1000) : 0;

  const { credit_card } = useStore();

  const [texto_copiar, set_texto_copiar] = useState("Copiar código de barra");

  const [invoice, set_invoice]: any = useState();

  const [loading, set_loading] = useState(false);

  const { set_sync_checkout } = useStore();

  const { id_negocio } = useStore();
  const { id_pedido } = useStore();


  const [status_invoice, set_status_invoice] = useState<TypePaymentStatus>({
    open: false,
    icon: "processing",
    title: "",
    legend: "",
  });

  const { external_link } = useStore();

  const { user } = useStore();

  const keys: any = {
    assinatura: "Assinatura",
    dinamometro_tracao: "Dinamômetro de tração",
    dinamometro_palmar: "Dinamômetro palmar"
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(invoice.codebar);
      set_texto_copiar("Código de barra copiado!");
    } catch (err) { }
  };

  const handleDownloadInvoice = () => {
    window.parent.postMessage(
      { type: "BOTAO_PRESSIONADO", payload: { url: invoice.url_boleto } },
      "*"
    );
  };

  function handleDownloadInvoiceExternal() {
    const link = document.createElement("a");
    link.href = invoice.url_boleto;
    link.download = "boleto.pdf";
    link.target = "_blank"; // opcional, para abrir em nova aba se for visualizável
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleReadyPayment = () => {
    set_status_invoice({
      icon: "processing",
      legend: "Aguarde o processamento de até 2 dias úteis do boleto.",
      open: true,
      title: "Pagamento sendo processado",
    });
  };

  const handleGenerateInvoice = async () => {
    set_loading(true);

    try {
      const data = await GenerateInvoice({
        id_negocio: id_negocio,
        id_pedido: id_pedido,
        produto: {
          formas_pagamento: formas,
          tipo: produto_type,
          entrada: entrada,
        }
      });

      if (data.status_code === 200) {
        onOpen();
        set_invoice(data);
        set_sync_checkout(true);
      } else {
        toast.error("Falha na geração da fatura: " + data.msg);
      }
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      set_loading(false);
    }
  };


  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40" />}
      <ButtonMethodPayment
        onClick={() => {
          if (loading === false) {
            AmplitudeLog("Checkout_Metodo_Selecionado", {
              finalidade_pagamento: entrada ? "entrada" : produto_type,
              tipo_produto: produto_type,
              metodo_escolhido: "boleto",
              origem_escolha: "primeira_etapa"
            });
            handleGenerateInvoice();
          }
        }}
        icon="boleto"
        theme={"white"}
        disabled={false}
        wide={wide}
        loading={loading}
      >
        Pague com Boleto
      </ButtonMethodPayment>
      <Drawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement={"bottom"}
        hideCloseButton
        onClose={() => {
          set_texto_copiar("Copiar código de barra");
          set_status_invoice({
            icon: "processing",
            legend: "",
            open: false,
            title: "",
          });
        }}
      >
        <DrawerContent
          className={`
          w-full
          rounded-t-[0.75rem]
          ${!isMobile && "!max-h-screen !h-[100vh] !rounded-none !border-none"}
          bg-white-primary px-[2rem] pb-[2rem]
          flex
          items-center
          !max-h-[100dvh]
        `}
        >
          {(onClose) => (
            <div
              className={`${!isMobile ? "w-[60%]" : "w-full"}`}
            >
              <div className="w-[100%] flex justify-end">
                <button
                  onClick={onClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    marginTop: "1.5rem",
                  }}
                >
                  <Close className="w-[1rem] h-[1rem]" />
                </button>
              </div>
              <ScrollArea className="h-[100%]">
                <div className="w-[100%] flex justify-center">
                  <p className="text-blue-primary text-[1.04rem] font-[700]">
                    Pagamento com Boleto
                  </p>
                </div>
                {!entrada &&
                  <Product
                    title={produto.plano ? produto.plano : keys[produto_type]}
                    valor={produto.valor}
                    total={produto.valor_total}
                    parcelas={produto.quantidade_parcelas}
                    unidades={produto.quantidade}
                    theme="gray"
                    imagem={produto_type}
                  />
                }
                <p className="text-gray-dark text-[1.04rem] mt-[1.44rem] font-[700]">
                  Fatura
                </p>
                <Invoice
                  duedate={entrada ? produto?.vencimento_fatura_entrada : produto?.vencimento_fatura}
                  price={entrada ? produto?.entrada : produto?.valor}
                  parcelas={produto?.quantidade_parcelas}
                  theme="default"
                  quantidade={produto?.quantidade}
                  entrada={entrada}
                />
                <hr />
                <div>
                  <p className="mt-[1.4rem]">
                    Caso deseje a{" "}
                    <strong>liberação imediata do seu acesso</strong>{" "}
                    recomendamos o pagamento por meio de{" "}
                    <strong>Cartão de crédito</strong> <strong>ou Pix.</strong>{" "}
                  </p>
                  <div className="flex flex-col gap-[0.75rem] mt-[2.20rem]">
                    <ButtomSave
                      icon={
                        texto_copiar === "Copiar código de barra"
                          ? "copy"
                          : "none"
                      }
                      theme="mediumgreen"
                      onClick={() => {
                        handleCopy();
                        // AutorizePayment();
                        AmplitudeLog("Checkout_Interacao_Pagamento_Off", {
                          acao: "copiar_codigo",
                          tempo_permanencia_modal: getModalTime()
                        });
                      }}
                    >
                      {texto_copiar}
                    </ButtomSave>
                    <ButtomSave
                      icon="download"
                      theme="white"
                      onClick={() => {
                        external_link === false
                          ? handleDownloadInvoiceExternal()
                          : handleDownloadInvoice();
                        // AutorizePayment();  
                        AmplitudeLog("Checkout_Interacao_Pagamento_Off", {
                          acao: "baixar_boleto",
                          tempo_permanencia_modal: getModalTime()
                        });
                      }}
                    >
                      Baixar boleto
                    </ButtomSave>
                    {external_link === false && isMobile && (
                      <ButtomSave
                        icon="share"
                        theme="white"
                        onClick={() => {
                          HandleShare(invoice.codebar);
                          // AutorizePayment();
                          AmplitudeLog("Checkout_Interacao_Pagamento_Off", {
                            acao: "compartilhar",
                            tempo_permanencia_modal: getModalTime()
                          });
                        }}
                      >
                        Compartilhar
                      </ButtomSave>
                    )}
                  </div>
                  <div className="flex flex-row items-center mt-[1.5rem]">
                    <p className="mr-1">Já fez o pagamento?</p>
                    <p
                      className="underline decoration-solid text-gray-dark"
                      onClick={() => {
                        handleReadyPayment();
                        AmplitudeLog("Checkout_Interacao_Pagamento_Off", {
                          acao: "confirmar_pagamento",
                          tempo_permanencia_modal: getModalTime()
                        });
                      }}
                    >
                      Clique aqui
                    </p>
                  </div>
                </div>
              </ScrollArea>
              <PaymentStatus
                icon={status_invoice.icon}
                legend={status_invoice.legend}
                open={status_invoice.open}
                title={status_invoice.title}
              />
            </div>
          )}
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default PaymentBoletoCheckout;
